import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const paTemplateListService = (params: Types.PATemplateListRequest) =>
  RestAPIClient.call<Types.PATemplateListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });
export const paTemplateListShortService = (
  params: Types.PATemplateListRequest
) =>
  RestAPIClient.call<Types.PATemplateListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      byPassError: true,
      params,
    },
  });

export const paTemplateListByUserService = (
  params: Types.PATemplateListRequest
) =>
  RestAPIClient.call<Types.PATemplateListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.Me,
    config: {
      requireAuthentication: true,
      byPassError: true,
      params,
    },
  });

export const paTemplateCreateService = (
  params: Types.PATemplateCreateRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const paTemplateDetailService = (id: string) =>
  RestAPIClient.call<Types.PATemplateDetail>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const paTemplateDetailFieldService = (id: string) =>
  RestAPIClient.call<Types.PATemplateDetail>({
    method: HTTPRequestMethods.GET,
    url: Paths.DetailField.replace("{id}", id),
    config: {
      requireAuthentication: true,
    },
  });

export const paTemplateDetailFieldMeService = (id: string) =>
  RestAPIClient.call<Types.PATemplateDetail>({
    method: HTTPRequestMethods.GET,
    url: Paths.DetailFieldMe.replace("{id}", id),
    config: {
      requireAuthentication: true,
    },
  });

export const paTemplateMeDetailService = (id: string) =>
  RestAPIClient.call<Types.PATemplateDetail>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.MeDetail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const paTemplateUpdateService = (
  params: Types.PATemplateUpdateRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const paTemplateDeleteService = (id: string) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const paTemplateFieldUpdateService = ({
  productivityTemplateId,
  id,
  status,
  index,
  columnName,
  columnNativeName,
  formula,
  productivityTemplateGroupFieldId,
}: {
  productivityTemplateId: string;
  id: string;
  status: number;
  index: number;
  columnName?: string;
  columnNativeName?: string;
  formula?: string;
  productivityTemplateGroupFieldId: string;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.UpdateField.replace("{id}", productivityTemplateId).replace(
      "{fieldId}",
      id
    )}`,
    config: {
      requireAuthentication: true,
    },
    data: {
      status,
      index,
      columnNativeName,
      columnName,
      productivityTemplateGroupFieldId,
      formula: formula || undefined,
    },
  });

export const paTemplateFieldUpdateBulkService = ({
  productivityTemplateId,
  items,
}: {
  productivityTemplateId: string;

  items: {
    id: string;
    status: number;
    index: number;
    columnName?: string;
    columnNativeName?: string;
    pattern?: string;
  }[];
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: Paths.UpdateFieldBulk.replace("{id}", productivityTemplateId),
    config: {
      requireAuthentication: true,
    },
    data: {
      items,
    },
  });

export const paTemplateGroupFieldUpdateService = ({
  id,
  productivityTemplateId,

  columnNativeName,
  columnName,
  status,
  index,
}: {
  id: string;
  productivityTemplateId: string;

  columnName?: string;
  columnNativeName: string;
  status: number;
  index: number;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: Paths.GroupUpdateField.replace("{id}", productivityTemplateId).replace(
      "{groupFieldId}",
      id
    ),
    config: {
      requireAuthentication: true,
    },
    data: {
      columnNativeName,
      columnName,
      status,
      index,
    },
  });

export const paTemplateGroupFieldUpdateBulkService = ({
  productivityTemplateId,
  items,
}: {
  productivityTemplateId: string;

  items: {
    columnName?: string;
    columnNativeName: string;
    status: number;
    index: number;
    id: string;
  }[];
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: Paths.GroupUpdateFieldBulk.replace("{id}", productivityTemplateId),
    config: {
      requireAuthentication: true,
    },
    data: {
      items,
    },
  });

export const paTemplateFieldCreateService = ({
  productivityTemplateId,
  index,
  fieldId,
  code,
  columnName,
  columnNativeName,
  dataType,
  groupData,
  formula,
}: {
  productivityTemplateId: string;
  index: number;
  fieldId?: string;
  code: string;
  columnName: string;
  columnNativeName: string;
  dataType: number;
  groupData: string;
  formula?: string;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.CreateField.replace("{id}", productivityTemplateId),
    config: {
      requireAuthentication: true,
    },
    data: {
      index,
      fieldId,
      code,
      columnName,
      columnNativeName,
      dataType,
      groupData,
      formula: formula || undefined,
    },
  });

export const paTemplateGroupFieldCreateService = ({
  id,
  ...rest
}: {
  id: string;
  code: string;
  columnName?: string;
  columnNativeName?: string;
  productivityTemplateFieldIds?: string[];
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.CreateGroupField.replace("{id}", id),
    config: {
      requireAuthentication: true,
    },
    data: rest,
  });

export const paTemplateFieldDeleteService = ({
  id,
  fieldId,
}: {
  id: string;
  fieldId: string;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.DELETE,
    url: Paths.DeleteField.replace("{id}", id).replace("{fieldId}", fieldId),
    config: {
      requireAuthentication: true,
    },
  });

export const paTemplateGroupFieldDeleteService = ({
  id,
  groupFieldId,
}: {
  id: string;
  groupFieldId: string;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.DELETE,
    url: Paths.DeleteGroupField.replace("{id}", id).replace(
      "{groupFieldId}",
      groupFieldId
    ),
    config: {
      requireAuthentication: true,
    },
  });

export const paPrintTemplateListService = ({
  templateId,
  page,
  limit,
  id,
  status,
  keyword,
  select,
}: {
  templateId: string;
  page?: number | null;
  limit?: number | null;
  id?: string | null;
  status?: number | null;
  keyword?: string | null;
  select?: string[] | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<Types.PAPrintTemplate>>({
    method: HTTPRequestMethods.GET,
    url: Paths.PrintTemplateList,
    config: {
      requireAuthentication: true,
      params: {
        page,
        limit,
        id,
        status,
        keyword,
        select,
        templateId,
      },
    },
  });

export const paPrintTemplateCreateService = ({
  name,
  nativeName,
  description,
  nativeDescription,
  fileName,
  templateId,
  groupBy,
}: {
  name?: string;
  nativeName: string;
  description?: string;
  nativeDescription: string;
  templateId: string;
  fileName: string;
  groupBy?: string;
}) =>
  RestAPIClient.call<Types.PAPrintTemplate>({
    method: HTTPRequestMethods.POST,
    url: Paths.PrintTemplateCreate,
    config: {
      requireAuthentication: true,
    },
    data: {
      name,
      nativeName,
      description,
      nativeDescription,
      fileName,
      productivityTemplateId: templateId,
      groupBy,
    },
  });

export const paPrintTemplateUpdateService = ({
  printTemplateId,
  name,
  description,
  fileName,
  nativeName,
  nativeDescription,
  groupBy,
}: {
  name?: string;
  nativeName: string;
  description?: string;
  nativeDescription: string;
  fileName: string;
  printTemplateId: string;
  groupBy?: string;
}) =>
  RestAPIClient.call<Types.PAPrintTemplate>({
    method: HTTPRequestMethods.PUT,
    url: Paths.PrintTemplateUpdate.replace("{id}", printTemplateId),
    config: {
      requireAuthentication: true,
    },
    data: {
      name,
      description,
      fileName,
      nativeName,
      nativeDescription,
      groupBy,
    },
  });

export const paPrintTemplateDetailService = (printTemplateId: string) =>
  RestAPIClient.call<Types.PAPrintTemplate>({
    method: HTTPRequestMethods.GET,
    url: Paths.PrintTemplateDetail.replace("{id}", printTemplateId),
    config: {
      requireAuthentication: true,
    },
  });

export const paPrintTemplateDeleteService = (printTemplateId: string) =>
  RestAPIClient.call<Types.PAPrintTemplate>({
    method: HTTPRequestMethods.DELETE,
    url: Paths.PrintTemplateDelete.replace("{id}", printTemplateId),
    config: {
      requireAuthentication: true,
    },
  });
